module.exports = __webpack_public_path__ + "static/digital-9d20d351019a98e1f8e773628f45dcc4.jpg";